import { User } from './user';

class BaseProject {
    public id: string;
    public name: string;
    public identifier: string;
    public description: string;
    public status!: number;     // TODO FIXME
    public is_open!: boolean;
    public parent_id!: string;
    public lft!: string;
    public rgt!: string;
    public effort_time_cap: number;
    public estimated_hours: number;
    public issues_by_status_kpi: {[k: string]: GroupPerformance};
    public spent_hours: number;
    public created_on!: Date;
    public updated_on!: Date;
    public business_unit!: string;
    public project_type!: string;
    public sampled_on!: string;
    public customer!: string;
    public document_repo_url!: string;
    public redmine_url!: string;
    public _cellVariants!: {[k: string]: any};
    public _rowVariant!: string;

    constructor() {
        this.id = '';
        this.name = '';
        this.identifier = '';
        this.description = '';
        this.effort_time_cap = 0;
        this.spent_hours = 0;
        this.estimated_hours = 0;
        this.issues_by_status_kpi = {}
    }
}

export class Project extends BaseProject {
    /*
     * @deprecated use effort_time_cap instead
     */
    public effort_cap: number;

    public done_ratio: number;
    public wps_done: number;
    public wps_total: number;
    public normalized_cost: number;
    public ebitda: number;
    public ebitda_with_sales: number;
    public hours_left: number;
    public expected_hours!: number;
    public progress: number | undefined;
    public eff_03!: number;
    public eff_04!: number;
    public eff_05!: number;
    public delivery_manager!: User;
    public children!: Array<Project>;

    constructor() {
        super()
        this.effort_cap = 0;    // deprecated
        this.done_ratio = 0;
        this.wps_done = 0;
        this.wps_total = 0;
        this.normalized_cost = 0;
        this.ebitda = 0;
        this.ebitda_with_sales = 0;
        this.hours_left = 0;
        this.progress = 0;
    }

    public get ebitda_ratio(): number {
        if (this.wps_done > 0 && this.ebitda > 0) {
            return this.ebitda/this.wps_done;
        }
        return 0;
    }

    public get ebitda_ratio_sales(): number {
        if (this.wps_done > 0 && this.ebitda_with_sales > 0) {
            return this.ebitda_with_sales/this.wps_done;
        }
        return 0;
    }
}

export class SalesProject extends BaseProject {
    constructor() {
        super()
    }
}

export class GroupPerformance {
    public estimated_hours: number;
    public spent_hours: number;

    constructor() {
        this.estimated_hours = 0;
        this.spent_hours = 0;
    }
}

export class TimeBasedPerformance {
    public spent_hours!: number;
    public spent_hours_normalized!: number;
    public cumulative_spent_hours!: number;
    public cumulative_spent_hours_normalized!: number;
    public cost_normalized!: number;
    public cumulative_cost_normalized!: number;
    public produced_value!: number;
    public cumulative_produced_value!: number;
    public done_percent!: number;
    public cumulative_done_percent!: number;

}

export class ProjectDailyPerformance {
    public day!: Date;
    public perfs?: TimeBasedPerformance;
}

export class ProjectWeeklyPerformance {
    public year!: number;
    public week!: number;
    public perfs?: TimeBasedPerformance;
}

export class ProjectMonthlyPerformance {
    public year!: number;
    public month!: number;
    public perfs?: TimeBasedPerformance;
}

class ProjectTimeBasedPerformance {
    public by_day?: Array<ProjectDailyPerformance>;
    public by_week?: Array<ProjectWeeklyPerformance>;
    public by_month?: Array<ProjectMonthlyPerformance>;
}

export class ProjectPerformance {
    public id: string;
    public name: string;
    public identifier: string;
    public time_performance?: ProjectTimeBasedPerformance;

    constructor() {
        this.id = '';
        this.name = '';
        this.identifier = '';
    }
}

export class ProjectPerformanceInterval {

    public time_slot: string;
    public total_performance: TimeBasedPerformance;

    constructor() {
        this.time_slot = '';
        this.total_performance = new TimeBasedPerformance();
    }
}

export class ProjectPerformanceSimple {
    public id: string;
    public name: string;
    public identifier: string;
    public business_unit?: string;
    public project_type?: string;

    //Start period
    public start_cumulative_spent_hours!: number;
    public start_cumulative_spent_hours_normalized!: number;
    public start_cumulative_cost_normalized!: number;
    public start_cumulative_produced_value!: number;
    public start_cumulative_done_percent!: number;

    //End period
    public end_cumulative_spent_hours!: number;
    public end_cumulative_spent_hours_normalized!: number;
    public end_cumulative_cost_normalized!: number;
    public end_cumulative_produced_value!: number;
    public end_cumulative_done_percent!: number;

    public time_slots: Array<ProjectPerformanceInterval>

    constructor() {
        this.id = '';
        this.name = '';
        this.identifier = '';
        this.time_slots = new Array<ProjectPerformanceInterval>();
    }
}

export class ProjectTableUtils {
    public name: string;
    public business_unit?: string;
    public project_type?: string;
        //Start period
        public start_cumulative_spent_hours!: number;
        public start_cumulative_spent_hours_normalized!: number;
        public start_cumulative_cost_normalized!: number;
        public start_cumulative_produced_value!: number;
        public start_cumulative_done_percent!: number;

        //End period
        public end_cumulative_spent_hours!: number;
        public end_cumulative_spent_hours_normalized!: number;
        public end_cumulative_cost_normalized!: number;
        public end_cumulative_produced_value!: number;
        public end_cumulative_done_percent!: number;
    public slotValues: Map<string,TimeBasedPerformance>

    constructor() {
        this.name = '';
        this.slotValues = new Map<string,TimeBasedPerformance>();
    }

}

export class SlotValues {
    public timeSlot: string;
    public total_performance: TimeBasedPerformance

    constructor() {
        this.timeSlot = '';
        this.total_performance = new TimeBasedPerformance();
    }
}